<ng-container *ngIf="!embedOnboardOnly">
<div class="hack-reference-page tanuh-themed-page">
  <app-asset-header [config]="headerConfig" variant="tanuh"></app-asset-header>

  <main class="hack-main">
    <div class="hack-container">
      <section class="hack-section">
        <div class="hack-listing filter-layout-popup">
          <app-asset-grid
            [assets]="pagedListingAssets"
            assetType="dataset"
            searchPlaceholder="Search for Datasets"
            [searchQuery]="listingSearchQuery"
            [currentPage]="listingCurrentPage"
            [totalPages]="listingTotalPages"
            [viewMode]="listingViewMode"
            [itemsPerPage]="listingItemsPerPage"
            [showMobileFilterButton]="true"
            filterLayout="popup"
            [activeFilterCount]="filterConfig.activeFilterCount"
            [isLoggedIn]="isLoggedIn"
            [showBookmarkLikeButtons]="false"
            datasetCardVariant="reference"
            [sortOption]="listingSortOption"
            [loading]="isListingLoading"
            [skeletonCount]="listingItemsPerPage"
            (searchChange)="onListingSearchChange($event)"
            (sortChange)="onListingSortChange($event)"
            (viewModeChange)="onListingViewModeChange($event)"
            (pageChange)="onListingPageChange($event)"
            (itemsPerPageChange)="onListingItemsPerPageChange($event)"
            (openMobileFilter)="openListingFilter()"
            (referenceDatasetSubmitModel)="onListingSubmitModel($event)"
          ></app-asset-grid>
        </div>
      </section>

      <div
        class="hack-listing__filter-overlay"
        [class.active]="isListingFilterOpen"
        (click)="closeListingFilter()"
      ></div>
      <div
        class="hack-listing__filter-dialog"
        [class.active]="isListingFilterOpen"
        role="dialog"
        aria-modal="true"
        aria-label="Filter Benchmarking Datasets"
        (click)="$event.stopPropagation()"
      >
        <div class="hack-listing__filter-header">
          <div class="hack-listing__filter-heading">
            <span class="hack-listing__filter-heading-icon" aria-hidden="true">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M22 3H2L10 12.46V19L14 21V12.46L22 3Z"></path>
              </svg>
            </span>
            <h2 class="hack-listing__filter-title">Filter Datasets</h2>
          </div>
          <button
            type="button"
            class="hack-listing__filter-close"
            (click)="closeListingFilter()"
            aria-label="Close filters"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
        <div class="hack-listing__filter-content">
          <app-asset-filter
            [config]="filterConfig"
            searchPlaceholder="Search for datasets"
            [isLoggedIn]="isLoggedIn"
            (filterChange)="onListingFilterChange($event)"
            (resetFilters)="onResetListingFilters()"
          ></app-asset-filter>
        </div>
        <div class="hack-listing__filter-footer">
          <button
            type="button"
            class="hack-listing__filter-reset"
            (click)="onResetListingFilters()"
            *ngIf="filterConfig.activeFilterCount > 0"
          >
            Reset
          </button>
          <button
            type="button"
            class="hack-listing__filter-apply"
            (click)="closeListingFilter()"
          >
            Apply Filter ({{ filterConfig.activeFilterCount }})
          </button>
        </div>
      </div>

  </div>
</main>

<app-footer></app-footer>
</div>
</ng-container>
<app-login-modal *ngIf="showLoginModal" (visibleChange)="showLoginModal = false"></app-login-modal>

<div *ngIf="embedOnboardOnly" class="hack-onboard-page">
  <header class="hack-onboard-hero">
    <div class="hack-onboard-hero__icon" aria-hidden="true">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"
        stroke-linecap="round" stroke-linejoin="round">
        <path d="M12 2 2 7l10 5 10-5-10-5Z"></path>
        <path d="m2 12 10 5 10-5"></path>
        <path d="m2 17 10 5 10-5"></path>
      </svg>
    </div>
    <div class="hack-onboard-hero__text">
      <h1 class="hack-onboard-hero__title">Submit Model</h1>
      <p class="hack-onboard-hero__subtitle">
        Link your model to a benchmarking dataset and upload the required artifacts for evaluation.
      </p>
    </div>
  </header>

  <div class="hack-onboard-modal__content">
    <nav class="hack-onboard-stepper" aria-label="Submit model steps">
      <ol class="hack-onboard-stepper__list">
        <li
          *ngFor="let step of onboardPageSteps; let last = last"
          class="hack-onboard-stepper__item"
          [class.is-active]="wizardStep === step.id"
          [class.is-done]="wizardStep > step.id"
        >
          <span class="hack-onboard-stepper__index">
            <svg *ngIf="wizardStep > step.id" width="12" height="12" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M20 6L9 17l-5-5"></path>
            </svg>
            <ng-container *ngIf="wizardStep <= step.id">{{ step.id }}</ng-container>
          </span>
          <span class="hack-onboard-stepper__copy">
            <span class="hack-onboard-stepper__label">{{ step.label }}</span>
            <span class="hack-onboard-stepper__hint">{{ step.hint }}</span>
          </span>
          <span *ngIf="!last" class="hack-onboard-stepper__line" aria-hidden="true"></span>
        </li>
      </ol>
    </nav>

    <div class="hack-onboard-modal__body">
    <p
      *ngIf="onboardStatusMessage && wizardStep !== 4"
      class="hack-onboard-modal__status"
      [class.hack-onboard-modal__status--error]="!isOnboardSubmitting && !isOnboardTeeVerifying"
      aria-live="polite"
    >
      {{ onboardStatusMessage }}
    </p>

    <div class="hack-onboard-form">
      <section *ngIf="wizardStep === 1" class="hack-onboard-form__section hack-onboard-form__section--dataset">
        <div class="hack-onboard-form__section-head">
          <div>
            <h3 class="hack-onboard-form__section-title">
              Dataset <span class="hack-onboard-form__required">*</span>
            </h3>
            <p class="hack-onboard-form__section-desc">Your model will be evaluated against this benchmarking dataset.</p>
          </div>
        </div>
        <div class="hack-onboard-form__field">
          <div
            *ngIf="selectedDatasetLabel; else onboardDatasetPicker"
            class="hack-onboard-form__dataset-display"
            aria-readonly="true"
          >
            <span class="hack-onboard-form__dataset-icon" aria-hidden="true">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"
                stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="16" rx="2"></rect>
                <path d="M3 9h18"></path>
                <path d="M9 9v11"></path>
              </svg>
            </span>
            <span class="hack-onboard-form__dataset-name">{{ selectedDatasetLabel }}</span>
            <span class="hack-onboard-form__dataset-check" aria-hidden="true">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 6L9 17l-5-5"></path>
              </svg>
            </span>
          </div>
          <ng-template #onboardDatasetPicker>
            <app-single-select
              [options]="onboardDatasetOptions"
              optionLabel="label"
              placeholder="Select a dataset"
              [(ngModel)]="selectedDataset"
            ></app-single-select>
          </ng-template>
          <p class="hack-onboard-form__field-note">
            The ground truth template for model providers should use the file and label format.
          </p>
        </div>
      </section>

      <section *ngIf="wizardStep === 2" class="hack-onboard-form__section hack-onboard-form__section--tee-verify">
        <div class="hack-onboard-form__section-head">
          <div>
            <h3 class="hack-onboard-form__section-title">Verify Trusted Execution Environment</h3>
            <p class="hack-onboard-form__section-desc">
              Attest the TEE and review its identity before uploading your model.
            </p>
          </div>
        </div>

        <div *ngIf="!onboardTeeVerified" class="hack-onboard-tee-confirm">
          <div class="hack-onboard-tee-confirm__copy">
            <span class="hack-onboard-tee-confirm__icon" aria-hidden="true">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 13c0 5-3.5 7.5-8 10.5C7 20.5 4 18 4 13V6l8-3 8 3v7z"></path>
              </svg>
            </span>
            <div>
              <p class="hack-onboard-tee-confirm__title">Confirm the secure environment</p>
              <p class="hack-onboard-tee-confirm__desc">Run a secure identity check before any model files are selected.</p>
            </div>
          </div>
          <button
            type="button"
            class="hack-onboard-form__verify-tee-btn"
            [disabled]="isOnboardTeeVerifying || isOnboardSubmitting || onboardTransferComplete"
            (click)="verifyOnboardTee()"
          >
            <span
              *ngIf="isOnboardTeeVerifying"
              class="hack-onboard-attest-step__spinner"
              aria-hidden="true"
            ></span>
            <svg *ngIf="!isOnboardTeeVerifying" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
            </svg>
            {{ isOnboardTeeVerifying ? 'Verifying…' : 'Verify Trusted Execution Environment' }}
          </button>
        </div>

        <div
          *ngIf="onboardTeeVerified && onboardAttestationOidc as oidc"
          class="hack-onboard-tee-identity"
        >
          <div class="hack-onboard-tee-identity__head">
            <span class="hack-onboard-tee-identity__shield" aria-hidden="true">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 13c0 5-3.5 7.5-8 10.5C7 20.5 4 18 4 13V6l8-3 8 3v7z"></path>
              </svg>
            </span>
            <h4 class="hack-onboard-result__title">Verified Buffer TEE Identity</h4>
            <span class="hack-onboard-tee-identity__badge">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"
                stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M20 13c0 5-3.5 7.5-8 10.5C7 20.5 4 18 4 13V6l8-3 8 3v7z"></path>
                <path d="m9 12 2 2 4-4"></path>
              </svg>
              Verified
            </span>
          </div>
          <div class="hack-onboard-tee-identity__body">
            <dl class="hack-onboard-result__grid">
              <div class="hack-onboard-result__row">
                <dt>Image digest</dt>
                <dd><code>{{ oidc.submods?.container?.image_digest ?? '—' }}</code></dd>
              </div>
              <div class="hack-onboard-result__row">
                <dt>Hardware model</dt>
                <dd>{{ oidc.hwmodel ?? '—' }}</dd>
              </div>
              <div class="hack-onboard-result__row">
                <dt>OIDC issuer</dt>
                <dd>{{ oidc.iss ?? '—' }}</dd>
              </div>
              <div class="hack-onboard-result__row">
                <dt>Audience</dt>
                <dd>{{ onboardOidcAudience }}</dd>
              </div>
              <div class="hack-onboard-result__row">
                <dt>Issued at</dt>
                <dd>{{ formatOnboardTimestamp(oidc.iat) }}</dd>
              </div>
              <div class="hack-onboard-result__row">
                <dt>Expires at</dt>
                <dd>{{ formatOnboardTimestamp(oidc.exp) }}</dd>
              </div>
            </dl>
            <label
              *ngIf="!onboardTransferComplete"
              class="hack-onboard-form__attest-accept"
            >
              <input
                type="checkbox"
                [checked]="onboardAttestationAccepted"
                [disabled]="isOnboardSubmitting"
                (change)="onOnboardAttestationAcceptedChange($any($event.target).checked)"
              />
              <span>I have verified the attestation evidence and I am ready to proceed</span>
            </label>
          </div>
        </div>
      </section>

      <section
        *ngIf="wizardStep === 3"
        id="onboardUploadSection"
        class="hack-onboard-form__section hack-onboard-form__section--uploads"
      >
        <div class="hack-onboard-form__section-head">
          <div>
            <h3 class="hack-onboard-form__section-title">Upload model files</h3>
            <p class="hack-onboard-form__section-desc">Provide your model package and trained weights for sandbox evaluation.</p>
          </div>
        </div>

        <div class="hack-onboard-form__upload-grid">
          <div class="hack-onboard-form__field">
            <label class="hack-onboard-form__label" for="onboardModelFile">
              <span class="hack-onboard-form__label-icon hack-onboard-form__label-icon--model" aria-hidden="true">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                </svg>
              </span>
              Model <span class="hack-onboard-form__required">*</span>
            </label>
            <p class="hack-onboard-form__hint">Accepted files: <strong>{{ onboardModelFileAcceptLabel }}</strong></p>
            <div class="hack-onboard-form__file-upload-wrapper">
              <input
                type="file"
                id="onboardModelFile"
                class="hack-onboard-form__file-input"
                [attr.accept]="onboardModelFileAccept"
                [disabled]="isOnboardSubmitting || onboardTransferComplete || isModelFileBuffering"
                (change)="onModelFileSelected($event)"
              />
              <div
                class="hack-onboard-form__dropzone-row"
                [class.hack-onboard-form__dropzone-row--filled]="!!modelFile"
              >
                <label
                  for="onboardModelFile"
                  class="hack-onboard-form__dropzone"
                  [class.hack-onboard-form__dropzone--filled]="!!modelFile"
                  [class.hack-onboard-form__dropzone--uploading]="isModelFileBuffering || isOnboardSubmitting"
                >
                  <span class="hack-onboard-form__dropzone-icon" aria-hidden="true">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"
                      stroke-linecap="round" stroke-linejoin="round">
                      <path d="M12 3v12"></path>
                      <path d="m7 8 5-5 5 5"></path>
                      <path d="M5 21h14"></path>
                      <path d="M5 16v5"></path>
                      <path d="M19 16v5"></path>
                    </svg>
                  </span>
                  <ng-container *ngIf="!modelFile; else modelFileSelected">
                    <span class="hack-onboard-form__dropzone-title">Drop model file or browse</span>
                  </ng-container>
                  <ng-template #modelFileSelected>
                    <span class="hack-onboard-form__file-copy">
                      <span class="hack-onboard-form__file-name">{{ modelFile?.name }}</span>
                      <span class="hack-onboard-form__file-meta">{{ formatOnboardFileSize(modelFile!.size) }}</span>
                    </span>
                  </ng-template>
                  <span
                    *ngIf="modelFile"
                    class="hack-onboard-form__file-check"
                    aria-hidden="true"
                  >
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"
                      stroke-linecap="round" stroke-linejoin="round">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span>
                </label>
                <button
                  *ngIf="modelFile && !isModelFileBuffering && !isOnboardSubmitting && !onboardTransferComplete"
                  type="button"
                  class="hack-onboard-form__file-delete-icon"
                  (click)="$event.preventDefault(); $event.stopPropagation(); clearModelFile('onboardModelFile')"
                  aria-label="Remove model file"
                  title="Remove file"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                    <line x1="10" y1="11" x2="10" y2="17"></line>
                    <line x1="14" y1="11" x2="14" y2="17"></line>
                  </svg>
                </button>
              </div>
              <div
                *ngIf="showModelUploadProgress"
                class="hack-onboard-form__upload-progress"
                role="progressbar"
                [attr.aria-valuenow]="modelUploadProgress"
                aria-valuemin="0"
                aria-valuemax="100"
                [attr.aria-label]="'Model upload ' + modelUploadProgress + ' percent'"
              >
                <div class="hack-onboard-form__upload-progress-track">
                  <div
                    class="hack-onboard-form__upload-progress-fill"
                    [style.width.%]="modelUploadProgress"
                  ></div>
                </div>
                <span class="hack-onboard-form__upload-progress-value">{{ modelUploadProgress }}%</span>
              </div>
            </div>
          </div>

          <div class="hack-onboard-form__field">
            <label class="hack-onboard-form__label" for="onboardModelWeightsFile">
              <span class="hack-onboard-form__label-icon hack-onboard-form__label-icon--weights" aria-hidden="true">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"
                  stroke-linecap="round" stroke-linejoin="round">
                  <ellipse cx="12" cy="5" rx="8" ry="3"></ellipse>
                  <path d="M4 5v6c0 1.66 3.58 3 8 3s8-1.34 8-3V5"></path>
                  <path d="M4 11v6c0 1.66 3.58 3 8 3s8-1.34 8-3v-6"></path>
                </svg>
              </span>
              Model weights <span class="hack-onboard-form__required">*</span>
            </label>
            <p class="hack-onboard-form__hint">Accepted files: <strong>{{ onboardWeightsFileAcceptLabel }}</strong></p>
            <div class="hack-onboard-form__file-upload-wrapper">
              <input
                type="file"
                id="onboardModelWeightsFile"
                class="hack-onboard-form__file-input"
                [attr.accept]="onboardWeightsFileAccept"
                [disabled]="isOnboardSubmitting || onboardTransferComplete || isModelWeightsFileBuffering"
                (change)="onModelWeightsFileSelected($event)"
              />
              <div
                class="hack-onboard-form__dropzone-row"
                [class.hack-onboard-form__dropzone-row--filled]="!!modelWeightsFile"
              >
                <label
                  for="onboardModelWeightsFile"
                  class="hack-onboard-form__dropzone"
                  [class.hack-onboard-form__dropzone--filled]="!!modelWeightsFile"
                  [class.hack-onboard-form__dropzone--uploading]="isModelWeightsFileBuffering || isOnboardSubmitting"
                >
                  <span class="hack-onboard-form__dropzone-icon" aria-hidden="true">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"
                      stroke-linecap="round" stroke-linejoin="round">
                      <path d="M12 3v12"></path>
                      <path d="m7 8 5-5 5 5"></path>
                      <path d="M5 21h14"></path>
                      <path d="M5 16v5"></path>
                      <path d="M19 16v5"></path>
                    </svg>
                  </span>
                  <ng-container *ngIf="!modelWeightsFile; else weightsFileSelected">
                    <span class="hack-onboard-form__dropzone-title">Drop weights file or browse</span>
                  </ng-container>
                  <ng-template #weightsFileSelected>
                    <span class="hack-onboard-form__file-copy">
                      <span class="hack-onboard-form__file-name">{{ modelWeightsFile?.name }}</span>
                      <span class="hack-onboard-form__file-meta">{{ formatOnboardFileSize(modelWeightsFile!.size) }}</span>
                    </span>
                  </ng-template>
                  <span
                    *ngIf="modelWeightsFile"
                    class="hack-onboard-form__file-check"
                    aria-hidden="true"
                  >
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"
                      stroke-linecap="round" stroke-linejoin="round">
                      <path d="M20 6L9 17l-5-5"></path>
                    </svg>
                  </span>
                </label>
                <button
                  *ngIf="modelWeightsFile && !isModelWeightsFileBuffering && !isOnboardSubmitting && !onboardTransferComplete"
                  type="button"
                  class="hack-onboard-form__file-delete-icon"
                  (click)="$event.preventDefault(); $event.stopPropagation(); clearModelWeightsFile('onboardModelWeightsFile')"
                  aria-label="Remove model weights file"
                  title="Remove file"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                    <line x1="10" y1="11" x2="10" y2="17"></line>
                    <line x1="14" y1="11" x2="14" y2="17"></line>
                  </svg>
                </button>
              </div>
              <div
                *ngIf="showModelWeightsUploadProgress"
                class="hack-onboard-form__upload-progress"
                role="progressbar"
                [attr.aria-valuenow]="modelWeightsUploadProgress"
                aria-valuemin="0"
                aria-valuemax="100"
                [attr.aria-label]="'Model weights upload ' + modelWeightsUploadProgress + ' percent'"
              >
                <div class="hack-onboard-form__upload-progress-track">
                  <div
                    class="hack-onboard-form__upload-progress-fill"
                    [style.width.%]="modelWeightsUploadProgress"
                  ></div>
                </div>
                <span class="hack-onboard-form__upload-progress-value">{{ modelWeightsUploadProgress }}%</span>
              </div>
            </div>
          </div>
        </div>

        <div
          *ngIf="showPythonUploadField || embedOnboardOnly"
          class="hack-onboard-form__field hack-onboard-form__field--full"
        >
          <label class="hack-onboard-form__label" for="onboardPythonFile">
            <span class="hack-onboard-form__label-icon hack-onboard-form__label-icon--script" aria-hidden="true">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
              </svg>
            </span>
            Preprocessing script <span class="hack-onboard-form__required">*</span>
          </label>
          <p class="hack-onboard-form__hint">Accepted files: <strong>.py</strong></p>
          <div class="hack-onboard-form__file-upload-wrapper">
            <input
              type="file"
              id="onboardPythonFile"
              class="hack-onboard-form__file-input"
              accept=".py"
              [disabled]="isOnboardSubmitting || onboardTransferComplete || isPythonFileBuffering"
              (change)="onPythonFileSelected($event)"
            />
            <div
              class="hack-onboard-form__dropzone-row"
              [class.hack-onboard-form__dropzone-row--filled]="!!pythonFile"
            >
              <label
                for="onboardPythonFile"
                class="hack-onboard-form__dropzone"
                [class.hack-onboard-form__dropzone--filled]="!!pythonFile"
                [class.hack-onboard-form__dropzone--uploading]="isPythonFileBuffering || isOnboardSubmitting"
              >
                <span class="hack-onboard-form__dropzone-icon" aria-hidden="true">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M12 3v12"></path>
                    <path d="m7 8 5-5 5 5"></path>
                    <path d="M5 21h14"></path>
                    <path d="M5 16v5"></path>
                    <path d="M19 16v5"></path>
                  </svg>
                </span>
                <ng-container *ngIf="!pythonFile; else pythonFileSelected">
                  <span class="hack-onboard-form__dropzone-title">Drop preprocessing.py or browse</span>
                </ng-container>
                <ng-template #pythonFileSelected>
                  <span class="hack-onboard-form__file-copy">
                    <span class="hack-onboard-form__file-name">{{ pythonFile?.name }}</span>
                    <span class="hack-onboard-form__file-meta">{{ formatOnboardFileSize(pythonFile!.size) }}</span>
                  </span>
                </ng-template>
                <span
                  *ngIf="pythonFile"
                  class="hack-onboard-form__file-check"
                  aria-hidden="true"
                >
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 6L9 17l-5-5"></path>
                  </svg>
                </span>
              </label>
              <button
                *ngIf="pythonFile && !isPythonFileBuffering && !isOnboardSubmitting && !onboardTransferComplete"
                type="button"
                class="hack-onboard-form__file-delete-icon"
                (click)="$event.preventDefault(); $event.stopPropagation(); clearPythonFile('onboardPythonFile')"
                aria-label="Remove python script file"
                title="Remove file"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <polyline points="3 6 5 6 21 6"></polyline>
                  <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                  <line x1="10" y1="11" x2="10" y2="17"></line>
                  <line x1="14" y1="11" x2="14" y2="17"></line>
                </svg>
              </button>
            </div>
            <div
              *ngIf="showPythonUploadProgress"
              class="hack-onboard-form__upload-progress"
              role="progressbar"
              [attr.aria-valuenow]="pythonUploadProgress"
              aria-valuemin="0"
              aria-valuemax="100"
              [attr.aria-label]="'Python script upload ' + pythonUploadProgress + ' percent'"
            >
              <div class="hack-onboard-form__upload-progress-track">
                <div
                  class="hack-onboard-form__upload-progress-fill"
                  [style.width.%]="pythonUploadProgress"
                ></div>
              </div>
              <span class="hack-onboard-form__upload-progress-value">{{ pythonUploadProgress }}%</span>
            </div>
          </div>
          <p class="hack-onboard-form__field-note">
            The ground truth template for model providers should use the file and label format.
          </p>
        </div>

        <div class="hack-onboard-form__encrypt-note">
          <span class="hack-onboard-form__encrypt-note-icon" aria-hidden="true">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"
              stroke-linecap="round" stroke-linejoin="round">
              <rect x="5" y="11" width="14" height="10" rx="2"></rect>
              <path d="M8 11V8a4 4 0 0 1 8 0v3"></path>
            </svg>
          </span>
          <p>Your files are encrypted before leaving this browser and sent only to the verified environment.</p>
        </div>
      </section>

      <section
        *ngIf="wizardStep === 4"
        class="hack-onboard-form__section hack-onboard-form__section--attestation"
      >
        <div class="hack-onboard-form__section-head">
          <div>
            <h3 class="hack-onboard-form__section-title">Transfer progress</h3>
            <p class="hack-onboard-form__section-desc">
              Encrypted model transfer progress to the attested Buffer TEE.
            </p>
          </div>
        </div>

        <ul class="hack-onboard-attest-steps" aria-label="Attestation and transfer progress">
          <li
            *ngFor="let step of onboardAttestationSteps"
            class="hack-onboard-attest-step"
            [class.hack-onboard-attest-step--active]="step.status === 'active'"
            [class.hack-onboard-attest-step--done]="step.status === 'done'"
            [class.hack-onboard-attest-step--error]="step.status === 'error'"
            [class.hack-onboard-attest-step--pending]="step.status === 'pending'"
            [class.hack-onboard-attest-step--tee-verified]="step.id === 'verify' && step.status === 'done'"
          >
            <span class="hack-onboard-attest-step__icon" aria-hidden="true">
              <svg
                *ngIf="step.status === 'done'"
                class="hack-onboard-attest-step__glyph"
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
              <span
                *ngIf="step.status === 'active'"
                class="hack-onboard-attest-step__spinner"
              ></span>
              <svg
                *ngIf="step.status === 'error'"
                class="hack-onboard-attest-step__glyph"
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </span>
            <div class="hack-onboard-attest-step__body">
              <span class="hack-onboard-attest-step__title">{{ step.title }}</span>
              <span class="hack-onboard-attest-step__detail">{{ step.detail }}</span>
            </div>
          </li>
        </ul>

        <div
          *ngIf="onboardTransferFailed"
          class="hack-onboard-transfer-failed"
          role="alert"
        >
          <div class="hack-onboard-transfer-failed__copy">
            <p class="hack-onboard-transfer-failed__title">Transfer failed</p>
            <p class="hack-onboard-transfer-failed__desc">
              The transfer could not be completed. Please check your connection and try again, or go back to re-upload your files.
            </p>
          </div>
          <button
            type="button"
            class="hack-onboard-transfer-failed__retry"
            (click)="retryOnboardTransfer()"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25"
              stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <polyline points="1 4 1 10 7 10"></polyline>
              <path d="M3.51 15a9 9 0 1 0 .49-4.5"></path>
            </svg>
            Retry
          </button>
        </div>

        <div *ngIf="onboardTransferComplete" class="hack-onboard-transfer-success">
          <p class="hack-onboard-transfer-success__msg">
            <span class="hack-onboard-transfer-success__check" aria-hidden="true">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 6L9 17l-5-5"></path>
              </svg>
            </span>
            Model submitted successfully
          </p>
          <button
            type="button"
            class="hack-onboard-modal__btn hack-onboard-modal__btn--primary hack-onboard-transfer-success__btn"
            (click)="viewOnboardSubmission()"
          >
            View submission
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25"
              stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <polyline points="9 18 15 12 9 6"></polyline>
            </svg>
          </button>
        </div>
      </section>

    <div class="hack-onboard-modal__actions" *ngIf="!(embedOnboardOnly && onboardTransferComplete)">
      <div class="hack-onboard-modal__actions-row">
      <ng-container *ngIf="!onboardTransferComplete; else onboardTransferDoneActions">
        <button
          *ngIf="wizardStep > 1"
          type="button"
          class="hack-onboard-modal__btn hack-onboard-modal__btn--ghost"
          [disabled]="isOnboardSubmitting || isOnboardTeeVerifying"
          (click)="goWizardBack()"
        >
          Back
        </button>
        <div class="hack-onboard-modal__actions-end">
        <button
          type="button"
          class="hack-onboard-modal__btn hack-onboard-modal__btn--secondary"
          [disabled]="isOnboardSubmitting || isOnboardTeeVerifying"
          (click)="leaveSubmitModelFlow()"
        >
          Cancel
        </button>
        <button
          *ngIf="wizardStep < 3"
          type="button"
          class="hack-onboard-modal__btn hack-onboard-modal__btn--primary"
          [disabled]="!canGoWizardNext"
          (click)="goWizardNext()"
        >
          Next
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25"
            stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </button>
        <button
          *ngIf="wizardStep === 3"
          type="button"
          class="hack-onboard-modal__btn hack-onboard-modal__btn--primary"
          [disabled]="!isOnboardFormValid || isOnboardSubmitting"
          (click)="onOnboardConfirm()"
        >
          {{
            embedOnboardOnly
              ? (isOnboardSubmitting ? 'Sending…' : 'Send model securely')
              : (isOnboardSubmitting ? 'Uploading…' : 'Send Model to Trusted Execution Environment')
          }}
          <svg *ngIf="!isOnboardSubmitting" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25"
            stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </button>
        </div>
      </ng-container>
      <ng-template #onboardTransferDoneActions>
        <button
          type="button"
          class="hack-onboard-modal__btn hack-onboard-modal__btn--primary"
          (click)="closeOnboardModalAfterSuccess()"
        >
          Close
        </button>
      </ng-template>
      </div>
    </div>
    </div>
    </div>
  </div>
</div>
<app-modal
  [(visible)]="showEvaluateModal"
  [header]="''"
  [width]="'520px'"
  [modal]="true"
  [closable]="true"
  [showFooter]="false"
>
  <div class="hack-evaluate-modal">
    <div class="hack-evaluate-loader" aria-hidden="true"></div>
    <p>Your evaluation of the notebook is in place.<br>Please wait for a while !!</p>
  </div>
</app-modal>
<app-modal
  [visible]="showSandboxEvaluateSuccessModal"
  [header]="''"
  [width]="'520px'"
  [modal]="true"
  [closable]="true"
  [showFooter]="false"
  (visibleChange)="onSandboxEvaluateSuccessVisibleSync($event)"
>
  <div class="hack-sandbox-eval-success" *ngIf="sandboxEvaluateSuccessContext as ctx">
    <div class="hack-sandbox-eval-success__icon" aria-hidden="true">
      <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
        <polyline points="22 4 12 14.01 9 11.01"></polyline>
      </svg>
    </div>
    <p class="hack-sandbox-eval-success__title">Sandbox evaluation submitted</p>
    <p class="hack-sandbox-eval-success__desc">
      Your sandbox evaluation for <strong>{{ ctx.datasetTitle }}</strong> has been submitted successfully.
      Visit the leaderboard to view your <strong>ranking</strong> and <strong>score</strong>
    </p>
    <p class="hack-sandbox-eval-success__meta">
      Track: <code>{{ ctx.pvc }}</code>
    </p>
    <div class="hack-sandbox-eval-success__actions">
      <button type="button" class="hack-sandbox-eval-success__btn" (click)="closeSandboxEvaluateSuccessModal()">
        OK
      </button>
    </div>
  </div>
</app-modal>
<app-modal
  [(visible)]="showNotebookRunningModal"
  [header]="''"
  [width]="'min(92vw, 560px)'"
  [modal]="true"
  [closable]="!isNotebookListNavigating"
  [showFooter]="false"
>
  <div class="hack-nb-running-modal">
    <div class="hack-nb-running-modal__head">
      <div class="hack-nb-running-modal__icon" aria-hidden="true">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"
          stroke-linecap="round" stroke-linejoin="round">
          <rect x="2" y="3" width="20" height="14" rx="2"></rect>
          <line x1="8" y1="21" x2="16" y2="21"></line>
          <line x1="12" y1="17" x2="12" y2="21"></line>
          <path d="M10 9h4M10 12h2" stroke-width="2" stroke-linecap="round"></path>
        </svg>
      </div>
      <h3 class="hack-nb-running-modal__title">Stop Evaluating</h3>
    </div>
    <div class="hack-nb-running-modal__chip">
      <span class="hack-nb-running-modal__chip-label">Running notebook</span>
      <code class="hack-nb-running-modal__chip-value">{{ runningNotebookName }}</code>
    </div>
    <ol class="hack-nb-running-modal__steps">
      <li>Go to your notebook list.</li>
      <li>Use <strong>Stop</strong> on the running notebook.</li>
      <li>Come back to this page and click <strong>Evaluate</strong>.</li>
    </ol>
    <div class="hack-nb-running-modal__actions">
      <button
        type="button"
        class="hack-nb-running-modal__btn hack-nb-running-modal__btn--secondary"
        [disabled]="isNotebookListNavigating"
        (click)="closeNotebookRunningModal()"
      >
        Not now
      </button>
      <button
        type="button"
        class="hack-nb-running-modal__btn hack-nb-running-modal__btn--primary"
        [disabled]="isNotebookListNavigating"
        (click)="goToMyProjectsNotebookListFromRunningModal()"
      >
        {{ isNotebookListNavigating ? 'Opening…' : 'Go to notebook list' }}
      </button>
    </div>
  </div>
</app-modal>
<app-modal
  [(visible)]="showNoEvaluationModal"
  [header]="''"
  [width]="'520px'"
  [modal]="true"
  [closable]="true"
  [showFooter]="false"
>
  <div class="hack-evaluate-modal hack-evaluate-modal--empty">
    <p class="hack-evaluate-modal__empty-title">No evaluation found</p>
    <p class="hack-evaluate-modal__empty-desc">There are no evaluation workflows for this problem statement yet.</p>
  </div>
</app-modal>
<app-modal
  [(visible)]="showMyEvaluationsModal"
  [header]="''"
  [width]="'min(92vw, 960px)'"
  [modal]="true"
  [closable]="true"
  [showFooter]="false"
>
  <div class="hack-my-eval">
    <h3 class="hack-my-eval__title">My evaluations</h3>
    <p class="hack-my-eval__subtitle">Your evaluation workflow runs for this problem statement.</p>
    <div class="hack-my-eval__table-scroll">
      <table class="hack-my-eval__table">
        <thead>
          <tr>
            <th>Workflow</th>
            <th>Status</th>
            <th>Score</th>
            <th>Tests</th>
            <th>Created</th>
            <th>Finished</th>
            <th>Notes</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let row of myWorkflowRows">
            <tr>
              <td class="hack-my-eval__mono">
                <div>{{ row.workflow_name }}</div>
                <button
                  type="button"
                  class="hack-my-eval__log-toggle"
                  [disabled]="!row.id || isWorkflowLogLoading(row)"
                  (click)="toggleWorkflowLog(row)"
                >
                  {{ getWorkflowToggleLabel(row) }}
                </button>
              </td>
              <td><span [ngClass]="workflowStatusClass(row.status)">{{ row.status }}</span></td>
              <td>{{ formatWorkflowScore(row.score) }}</td>
              <td>
                <ng-container *ngIf="row.total_tests != null; else dashTests">
                  {{ row.passed_tests ?? 0 }}/{{ row.failed_tests ?? 0 }}/{{ row.total_tests }}
                </ng-container>
                <ng-template #dashTests>—</ng-template>
              </td>
              <td class="hack-my-eval__date">{{ formatWorkflowDate(row.created_at) }}</td>
              <td class="hack-my-eval__date">{{ formatWorkflowDate(row.finished_at) }}</td>
              <td class="hack-my-eval__notes">{{ row.error_message || '—' }}</td>
            </tr>
            <tr *ngIf="expandedWorkflowId === row.id" class="hack-my-eval__log-row">
              <td colspan="7">
                <div class="hack-my-eval__log-label">Output</div>
                <pre class="hack-my-eval__log-content">{{ getWorkflowLogText(row) }}</pre>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</app-modal>
